import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicCardText1, BasicCardText2, BasicCards } from "../../../../Constant";
import { BASIC_CARD } from "../../../../Data/Bonus Ui/BasicCard";
import { P } from "../../../../AbstractElements";

const BasicCard = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={BasicCards} span={BASIC_CARD} headerClass={true} />
        <CardBody>
          <P className="mb-0">
            {BasicCardText1}<em className="txt-danger">“module tabs”</em>{BasicCardText2}
          </P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicCard;
